module.exports = __webpack_public_path__ + "img/new-delete.9148007f.svg";